(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ShowcaseLayoutTemplateController', ShowcaseLayoutTemplateController);

    ShowcaseLayoutTemplateController.$inject = [
        '$state',
        '$translate',
        '$q',
        'ShowcaseLayoutTemplateService',
        'ModalFactory',
        'paginationConstants',
        'toastr',
        '$window',
        'systemConstants',
        'SHOWCASE_LAYOUT_TEMPLATE_CONSTANTS'
    ];

    function ShowcaseLayoutTemplateController(
        $state,
        $translate,
        $q,
        ShowcaseLayoutTemplateService,
        ModalFactory,
        paginationConstants,
        toastr,
        $window,
        systemConstants,
        SHOWCASE_LAYOUT_TEMPLATE_CONSTANTS
    ) {
        var vm = this;

        vm.isInitialLoading = true;
        vm.busy = false;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
        vm.loadingActionRequest = false;
        vm.loadingSelection = false;
        vm.removalLoading = false;
        vm.templates = [];
        vm.selectedTemplateIds = [];
        vm.search = '';
        vm.page = 0;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;
        vm.currentPage = 1;
        vm.totalItems = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.sortDirection = 'desc';

        vm.sortOptions = paginationConstants.sortOptions[$translate.use().toLowerCase()].filter(function (type) {
            return type.value === 'lastModifiedDate';
        });
        vm.selectedSortByOption = vm.sortOptions[0] || 'lastModifiedDate';
        vm.currentSortParam = 'lastModifiedDate,desc';

        vm.selectedActions = [
            {
                value: 'REMOVE',
                translation: 'showcase-layout-template.list.selection.actions.remove',
                actionFunc: function () {
                    return vm.removeSelectedTemplates();
                }
            }
        ];

        vm.selectionTypes = [
            {
                value: 'ALL_FROM_PAGE',
                translation: 'showcase-layout-template.list.selection.options.all-from-page'
            },
            {
                value: 'NONE',
                translation: 'showcase-layout-template.list.selection.options.none'
            }
        ];

        vm.$onInit = init;
        vm.loadTemplates = loadTemplates;
        vm.resetPage = resetPage;
        vm.changePage = changePage;
        vm.onChangeItemsPerPage = onChangeItemsPerPage;
        vm.onSelectedSortOption = onSelectedSortOption;
        vm.goToEdit = goToEdit;
        vm.removeTemplate = removeTemplate;
        vm.removeSelectedTemplates = removeSelectedTemplates;
        vm.getStatusLabel = getStatusLabel;
        vm.toggleTemplateSelection = toggleTemplateSelection;
        vm.isTemplateSelected = isTemplateSelected;
        vm.isAllSelected = isAllSelected;
        vm.isIndeterminate = isIndeterminate;
        vm.changeSelectionOfAllTemplates = changeSelectionOfAllTemplates;
        vm.selectItemsBy = selectItemsBy;
        vm.existsSelectedItems = existsSelectedItems;
        vm.goBack = goBack;

        function init() {
            vm.menuActions = getMenuActions();
            loadTemplates();
        }

        function getMenuActions() {
            return [
                {
                    name: 'edit',
                    icon: 'icon-ksc-pen-to-square-light',
                    label: 'entity.action.edit',
                    method: function (template) {
                        goToEdit(template.id);
                    }
                },
                {
                    name: 'delete',
                    icon: 'icon-ksc-trash-light',
                    label: 'entity.action.delete',
                    method: function (template) {
                        removeTemplate(template);
                    }
                }
            ];
        }

        function loadTemplates() {
            if (vm.busy) {
                return;
            }

            vm.busy = true;

            ShowcaseLayoutTemplateService.list({
                page: vm.page,
                size: vm.numPerPage,
                sort: buildSortParam()
            }, vm.search).then(function (response) {
                var headers = response.headers;
                vm.templates = response.data || [];
                vm.totalItems = parseInt(headers('X-Total-Count'), 10) || vm.templates.length;
                vm.startRegistry = vm.totalItems === 0 ? 0 : (vm.page * vm.numPerPage) + 1;
                vm.endRegistry = Math.min((vm.page + 1) * vm.numPerPage, vm.totalItems);
                vm.currentSortParam = buildSortParam();
                clearSelection();
                vm.isInitialLoading = false;
                vm.busy = false;
            }, function () {
                vm.isInitialLoading = false;
                vm.busy = false;
                toastr.error($translate.instant('showcase-layout-template.messages.load.error'));
            });
        }

        function buildSortParam() {
            var sortValue = angular.isObject(vm.selectedSortByOption)
                ? vm.selectedSortByOption.value
                : vm.selectedSortByOption;
            var direction = angular.isObject(vm.selectedSortByOption)
                ? vm.selectedSortByOption.direction
                : vm.sortDirection;
            return sortValue + ',' + (direction || 'asc');
        }

        function resetPage() {
            vm.page = 0;
            vm.currentPage = 1;
            loadTemplates();
        }

        function changePage() {
            vm.page = vm.currentPage - 1;
            loadTemplates();
        }

        function onChangeItemsPerPage(newValue) {
            if (newValue === vm.numPerPage) {
                return;
            }
            vm.numPerPage = newValue;
            resetPage();
        }

        function onSelectedSortOption(newValue) {
            if (!newValue) {
                return;
            }

            var nextSortParam = buildSortParamFromOption(newValue);
            vm.selectedSortByOption = newValue;
            vm.sortDirection = newValue.direction || 'asc';

            if (nextSortParam === vm.currentSortParam) {
                return;
            }

            vm.currentSortParam = nextSortParam;
            resetPage();
        }

        function buildSortParamFromOption(option) {
            if (!option) {
                return vm.currentSortParam;
            }
            var sortValue = angular.isObject(option) ? option.value : option;
            var direction = angular.isObject(option) ? option.direction : vm.sortDirection;
            return sortValue + ',' + (direction || 'asc');
        }

        function goToEdit(templateId) {
            $state.go('showcase-layout-templates.edit', { templateId: templateId });
        }

        function removeTemplate(template) {
            if (!template || !template.id) {
                return;
            }

            ModalFactory.openWarningModal(
                $translate.instant('showcase-layout-template.messages.delete.confirm.title'),
                $translate.instant('showcase-layout-template.messages.delete.confirm.subtitle', { name: template.name }),
                $translate.instant('showcase-layout-template.messages.delete.confirm.small-text'),
                null,
                $translate.instant('showcase-layout-template.messages.delete.confirm.confirm-button'),
                $translate.instant('entity.action.cancel'),
                function () {
                    vm.loadingActionRequest = true;
                    ShowcaseLayoutTemplateService.remove(template.id).then(function () {
                        toastr.success($translate.instant('showcase-layout-template.messages.delete.success'));
                        loadTemplates();
                    }).catch(function (error) {
                        handleDeleteError(error, template.name);
                    }).finally(function () {
                        vm.loadingActionRequest = false;
                        vm.removalLoading = false;
                    });
                }
            );
        }

        function removeSelectedTemplates() {
            if (vm.selectedTemplateIds.length < 1) {
                toastr.error($translate.instant('showcase-layout-template.messages.delete.none-selected'));
                return;
            }

            ModalFactory.openWarningModal(
                $translate.instant('showcase-layout-template.messages.delete.confirm-bulk.title'),
                $translate.instant('showcase-layout-template.messages.delete.confirm-bulk.subtitle', { amount: vm.selectedTemplateIds.length }),
                $translate.instant('showcase-layout-template.messages.delete.confirm-bulk.small-text'),
                null,
                $translate.instant('showcase-layout-template.messages.delete.confirm-bulk.confirm-button'),
                $translate.instant('entity.action.cancel'),
                function () {
                    vm.loadingActionRequest = true;
                    vm.removalLoading = true;
                    deleteTemplatesSequentially(vm.selectedTemplateIds.slice()).then(function (result) {
                        showBulkDeleteResult(result);
                        loadTemplates();
                    }).finally(function () {
                        vm.loadingActionRequest = false;
                        vm.removalLoading = false;
                    });
                }
            );
        }

        function deleteTemplatesSequentially(templateIds) {
            var result = {
                removed: 0,
                blockedMessages: []
            };

            function deleteNext(index) {
                if (index >= templateIds.length) {
                    return $q.resolve(result);
                }

                var templateId = templateIds[index];
                var template = vm.templates.find(function (item) {
                    return item.id === templateId;
                });

                return ShowcaseLayoutTemplateService.remove(templateId).then(function () {
                    result.removed++;
                    return deleteNext(index + 1);
                }, function (error) {
                    var message = getDeleteWarningMessage(error, template && template.name);
                    if (message) {
                        result.blockedMessages.push(message);
                    } else if (error && error.status) {
                        toastr.error($translate.instant('showcase-layout-template.messages.delete.error'));
                    }
                    return deleteNext(index + 1);
                });
            }

            return deleteNext(0);
        }

        function showBulkDeleteResult(result) {
            if (result.removed > 0) {
                toastr.success($translate.instant('showcase-layout-template.messages.delete.success'));
            }

            result.blockedMessages.forEach(function (message) {
                toastr.warning(message);
            });
        }

        function handleDeleteError(error, templateName) {
            var message = getDeleteWarningMessage(error, templateName);
            if (message) {
                toastr.warning(message);
                return;
            }
            if (error && error.status) {
                toastr.error($translate.instant('showcase-layout-template.messages.delete.error'));
            }
        }

        function getDeleteWarningMessage(error, templateName) {
            if (!isTemplateInUseError(error)) {
                return null;
            }
            if (templateName) {
                return $translate.instant('showcase-layout-template.messages.delete.in-use-named', { name: templateName });
            }
            return $translate.instant('showcase-layout-template.messages.delete.in-use');
        }

        function isTemplateInUseError(error) {
            if (!error) {
                return false;
            }
            if (error.status === 409) {
                return true;
            }
            var rawMessage = getRawApiErrorMessage(error);
            return rawMessage === SHOWCASE_LAYOUT_TEMPLATE_CONSTANTS.DELETE_IN_USE_API_MESSAGE;
        }

        function getRawApiErrorMessage(error) {
            if (!error || error.data === undefined || error.data === null) {
                return null;
            }
            var data = error.data;
            if (angular.isString(data)) {
                return data;
            }
            if (data.message) {
                return data.message;
            }
            if (data.data && angular.isString(data.data)) {
                return data.data;
            }
            return null;
        }

        function toggleTemplateSelection(templateId) {
            var index = vm.selectedTemplateIds.indexOf(templateId);
            if (index !== -1) {
                vm.selectedTemplateIds.splice(index, 1);
            } else {
                vm.selectedTemplateIds.push(templateId);
            }
        }

        function isTemplateSelected(templateId) {
            return vm.selectedTemplateIds.indexOf(templateId) !== -1;
        }

        function isAllSelected() {
            return vm.templates.length > 0 && vm.selectedTemplateIds.length === vm.templates.length;
        }

        function isIndeterminate() {
            return vm.selectedTemplateIds.length > 0 && !isAllSelected();
        }

        function changeSelectionOfAllTemplates() {
            if (isAllSelected()) {
                clearSelection();
            } else {
                selectAllFromPage();
            }
        }

        function selectAllFromPage() {
            vm.selectedTemplateIds = vm.templates.map(function (template) {
                return template.id;
            });
        }

        function selectItemsBy(type) {
            if (type === 'ALL_FROM_PAGE') {
                selectAllFromPage();
            } else if (type === 'NONE') {
                clearSelection();
            }
        }

        function existsSelectedItems() {
            return vm.selectedTemplateIds && vm.selectedTemplateIds.length > 0;
        }

        function clearSelection() {
            vm.selectedTemplateIds = [];
        }

        function getStatusLabel(status) {
            return 'showcase-layout-template.status.' + (status || 'DRAFT');
        }

        function goBack() {
            $state.go('showcases');
        }
    }

})();
